import Image from 'next/legacy/image'
import { z } from 'zod'

import { StoryblokImage, generateImageLoader } from '@cinch-nx/data-storyblok'

import styles from './author-byline.module.css'
import { getDayMonthYearFormat } from '@cinch-labs/shared-util'

export interface AuthorBylineProps {
  name?: string
  image?: StoryblokImage
  latestPublishDate?: string | null
}

const imageSchema = z.object({
  filename: z.string(),
  alt: z.string().optional(),
})

export function AuthorByline({
  name,
  image,
  latestPublishDate,
}: AuthorBylineProps) {
  const actualImage = imageSchema.safeParse(image)

  return (
    <div className={styles.author}>
      <div className={styles.border}>
        {actualImage.success ? (
          <Image
            src={actualImage.data.filename}
            alt={actualImage.data.alt ?? 'An Image of the author'}
            width={210}
            height={210}
            loader={generateImageLoader({
              height: 210,
              widthOverride: 210,
              useSmartCrop: true,
            })}
          />
        ) : (
          <img src="/images/author-fallback.png" alt="Cinch logo" />
        )}
      </div>
      <div className={styles.textContainer}>
        <p>
          By {name || 'cinch'}
          <span className={styles.breakline} aria-hidden>
            |
          </span>
          <span className={styles.updatedOn}>
            Updated on {getDayMonthYearFormat(latestPublishDate ?? 0)}
          </span>
        </p>
      </div>
    </div>
  )
}
